export default {
  title: 'Extras para maior sucesso',
  description: 'Melhore o seu plano com funcionalidades adicionais',
  buttons: {
    continue: 'Continuar',
    no_app_for_now: 'Sem aplicação móvel por agora',
  },
  toasts: {
    something_went_wrong: 'Ocorreu um erro, tente atualizar a página ou contacte o suporte técnico!',
    failed_to_save_changes: 'Não foi possível guardar as alterações, contacte o suporte técnico!',
    changes_got_saved: 'Alterações guardadas com sucesso!',
  },
};
